module.exports = __webpack_public_path__ + "images/03614645f200727546d8c4e93061484c.svg";